module.exports = __webpack_public_path__ + "media/images/top/qa/office_search_banner-4eed1db990cbb8815d99465c70acb4ad.png";